import { render, staticRenderFns } from "./ds-manager-rzd-aghk.vue?vue&type=template&id=bafb01ac&scoped=true"
import script from "./ds-manager-rzd-aghk.vue?vue&type=script&lang=js"
export * from "./ds-manager-rzd-aghk.vue?vue&type=script&lang=js"
import style0 from "./ds-manager-rzd-aghk.vue?vue&type=style&index=0&id=bafb01ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafb01ac",
  null
  
)

/* custom blocks */
import block0 from "./ds-manager-rzd-aghk.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports